import { FC } from "react";
// Models
import { IInvoiceSummaryBreakdownByAccount } from "app/store/BillingInvoices/BillingInvoices.slice";
// MUI
import { TableCell, TableRow } from "@mui/material";
// Utilities
import { toNumberWithCommas } from "app/utilities/Utilities";

type Props = {
  summary: IInvoiceSummaryBreakdownByAccount;
}

const DashboardTableRow:FC<Props> = ({ summary }) => {
  return (
    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      <TableCell>
        {summary.account.company}
      </TableCell>
      <TableCell>
        {`$${toNumberWithCommas(summary.breakdown.outstanding.amount)}`}
      </TableCell>
      <TableCell>
        {`$${toNumberWithCommas(summary.breakdown.overdue.amount)}`}
      </TableCell>
      <TableCell>
        {`$${toNumberWithCommas(summary.breakdown.upcoming.amount)}`}
      </TableCell>
    </TableRow>
  )
}

export default DashboardTableRow;
